import classNames from 'classnames';
import React from 'react';

const styles = require('./Logo.module.scss');

type LogoVersion = 'original' | 'company' | 'talent' | 'neutral';
type LogoIntensity = 'light' | 'dark';
type LogoType = 'solo' | 'horizontal' | 'vertical';

type LogoSize = 'S' | 'M' | 'L' | 'XL';

export interface LogoProps {
  alt?: string;
  className?: string;
  decorative?: boolean;
  href?: string;
  intensity?: LogoIntensity;
  size?: LogoSize;
  type?: LogoType;
  version?: LogoVersion;
}

/* eslint-disable @typescript-eslint/no-var-requires */
const LOGOS: Record<string, string> = {
  'company_light_horizontal': require('../../../../app/assets/images/logos/svg/company_light_horizontal.svg'),
  'company_light_solo': require('../../../../app/assets/images/logos/svg/company_light_solo.svg'),
  'company_light_vertical': require('../../../../app/assets/images/logos/svg/company_light_vertical.svg'),
  'neutral_dark_horizontal': require('../../../../app/assets/images/logos/svg/neutral_dark_horizontal.svg'),
  'neutral_dark_solo': require('../../../../app/assets/images/logos/svg/neutral_dark_solo.svg'),
  'neutral_dark_vertical': require('../../../../app/assets/images/logos/svg/neutral_dark_vertical.svg'),
  'neutral_light_horizontal': require('../../../../app/assets/images/logos/svg/neutral_light_horizontal.svg'),
  'neutral_light_solo': require('../../../../app/assets/images/logos/svg/neutral_light_solo.svg'),
  'neutral_light_vertical': require('../../../../app/assets/images/logos/svg/neutral_light_vertical.svg'),
  'original_dark_horizontal': require('../../../../app/assets/images/logos/svg/original_dark_horizontal.svg'),
  'original_dark_vertical': require('../../../../app/assets/images/logos/svg/original_dark_vertical.svg'),
  'original_light_horizontal': require('../../../../app/assets/images/logos/svg/original_light_horizontal.svg'),
  'original_light_solo': require('../../../../app/assets/images/logos/svg/original_light_solo.svg'),
  'original_light_vertical': require('../../../../app/assets/images/logos/svg/original_light_vertical.svg'),
  'talent_light_horizontal': require('../../../../app/assets/images/logos/svg/talent_light_horizontal.svg'),
  'talent_light_solo': require('../../../../app/assets/images/logos/svg/talent_light_solo.svg'),
  'talent_light_vertical': require('../../../../app/assets/images/logos/svg/talent_light_vertical.svg'),
};
/* eslint-enable @typescript-eslint/no-var-requires */

const Logo: React.FC<LogoProps> = ({
  alt = 'Landing.Jobs',
  className,
  decorative = false,
  href,
  intensity = 'light',
  size = 'S',
  type = 'solo',
  version = 'original',
}) => {
  const key = `${version}_${intensity}_${type}`;

  if (!(key in LOGOS)) return null;

  const src = LOGOS[key];

  const image = (
    <img
      alt={decorative ? '' : alt}
      aria-hidden={decorative || undefined}
      className={classNames(styles.logo, styles[`size-${size}`], className)}
      src={src}
    />
  );

  if (href) {
    return <a href={href} aria-label={decorative ? alt : undefined}>{image}</a>;
  }

  return image;
};

export default Logo;
